// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2dxWy","select":"Header_select__4Q-JD","clinic":"Header_clinic__-oc55"};